import { useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { threadUnreadCountQuery } from "@/app/Threads/GraphQL/threadQueries";
import { ThreadStatusFilter } from "@/gql/graphql";

/**
 * Counted server-side across every thread, not from the loaded pages — the
 * badge has to say it holds something unread even when that thread is pages
 * down. Omit the status to count both sides of the split at once.
 */
export function useThreadUnreadCount(
  supplierId?: string | null,
  status?: ThreadStatusFilter,
) {
  const { data } = useGqlQuery(
    threadUnreadCountQuery,
    { supplier_id: supplierId ?? undefined, status },
    { refetchInterval: 5 * 60_000 },
  );

  return data?.unreadThreadCount ?? 0;
}
